import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss']
})
export class ToggleButtonComponent {
  // Este codigo fue generado por Github Copilot Chat
  @Input() isActive = false;
  @Input() label = '';
  @Output() toggleChange = new EventEmitter<void>();

  onToggle() {
    this.isActive = !this.isActive;
    this.toggleChange.emit(); // Emite el evento cuando se hace toggle
    // Este codigo fue generado por Github Copilot Chat
  }
}
